'use client';
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/party.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import https from "https";
import { useState, useEffect, useRef } from "react";
import Loading from "./loading";
import DatePicker from 'react-datepicker';
import TimePicker from 'react-time-picker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import ReCAPTCHA from 'react-google-recaptcha';

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPageData() {
  const query = `
{
  pageData: pageBy(id: "cG9zdDoxMzA=") {
    pageBan {
      bannerText
      bannerSlider {
        desktopImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
    privatePartyPage {
      overviewCreativeHeading
      overviewHeading
      overviewText
      formTitle
      exclusiveFloorTitle
      enableExclusiveMenu
      exclusiveMenu {
        exMenuType
        exMenuFile {
          node {
            mediaItemUrl
          }
        }
      }
      enableFloorPlans
      floorPlans {
        floorNumber
        floorNumberPlan {
          node {
            mediaItemUrl
          }
        }
      }    
    }
  }
  qlparties {
    nodes {
      title
      privateParty {
        description
        featuredImage {
          node {
            mediaItemUrl
          }
        }
        reservenowlink
      }
    }
  }
}
  `;

  const res = await fetch(
    `${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`,
    {
      httpsAgent: agent,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({query}),
      next: {
        revalidate: 60,
      },
    }
  );

  const { data } = await res.json();

  return data;
}

export default function PrivateParty() {

  const recaptchaRef = useRef();

  const deviceType = useDeviceType();

  const [captchaValue, setCaptchaValue] = useState(null);
  const [page_data, setPageData] = useState(null);

  const [page_banner_text, setPageBannerText] = useState("");
  const [page_banner_sliders, setPageBannerSliders] = useState([]);

  const [overview_creative_heading, setOverviewCreativeHeading] = useState("");
  const [overview_heading, setOverviewHeading] = useState("");
  const [overview_text, setOverviewText] = useState("");

  const [form_heading, setFormHeading] = useState("");
  const [exclusiveFloor_title, setExclusiveFloorTitle] = useState("");

  const [party_list, setPartyList] = useState([]);

  const [success_msg, setSuccessMesseage] = useState(null);
  const [error_messege, setErrorMessege] = useState(null);
  const [is_loading, setIsLoading] = useState(false);

  const [pre_loader_enabled, setPreLoaderEnable] = useState(true);

  const [ExclusiveMenuList, setExclusiveMenuList] = useState([]);
  const [FloorMenuList, setFloorMenuList] = useState([]);
  const [is_exclusiveMenu, setIsExclusiveMenu] = useState(false);
  const [is_floorPlans, setIsFloorPlans] = useState(false);

  const [formData, setFormData] = useState({
    title: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    emailAddress: '',
    numberOfGuests: '',
    date: '',
    time: '',
    subject: '',
    message: '',
    consent: false,
    type: 'Private Party Inquiry',
  });

  const [errors, setErrors] = useState({});
  const [inputTypes, setInputTypes] = useState({
    numberOfGuests: 'text',
    date: 'text',
    time: 'text',
  });

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    setErrors({
      ...errors,
      [name]: '',
    });

    if (name === 'numberOfGuests') {
      // Check if the input is a valid positive number
      if (value === '' || (Number(value) > 0 && !isNaN(value))) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        // Clear the error if the input is valid
        setErrors((prevErrors) => ({
          ...prevErrors,
          numberOfGuests: '',
        }));
      } else {
        // Set an error if the value is not valid (negative number or non-numeric input)
        setErrors((prevErrors) => ({
          ...prevErrors,
          numberOfGuests: 'Please enter a valid positive number.',
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      date: date,
    });
    setErrors({
      ...errors,
      date: '', // Clear error message for the date field
    });
  };

  const handleTimeChange = (time) => {
    setFormData({
      ...formData,
      time: time,
    });
    setErrors({
      ...errors,
      time: '', // Clear error message for the time field
    });
  };

  const handleFocus = (name, type) => {
    setInputTypes((prevTypes) => ({
      ...prevTypes,
      [name]: type,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    const phoneRegex = /^[\d\s()+-]+$/;
    if (!formData.title) newErrors.title = 'Title is required';
    if (!formData.firstName) newErrors.firstName = 'First name is required';
    if (!formData.lastName) newErrors.lastName = 'Last name is required';
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = 'Phone number is required';
    } else if (!phoneRegex.test(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Phone number is invalid';
    }
    if (!formData.emailAddress) {
      newErrors.emailAddress = 'Email address is required';
    } else if (!validateEmail(formData.emailAddress)) {
      newErrors.emailAddress = 'Email address is invalid';
    }
    if (!formData.numberOfGuests) newErrors.numberOfGuests = 'Number of guests is required';
    if (!formData.date) newErrors.date = 'Date is required';
    if (!formData.time) newErrors.time = 'Time is required';
    if (!formData.subject) newErrors.subject = 'Subject is required';
    if (!formData.message) newErrors.message = 'Message is required';
    if (!formData.consent) newErrors.consent = 'Consent is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length === 0) {

      if (!captchaValue) {
        setErrorMessege('Please verify the reCAPTCHA.');
        return;
      }

      // if (!captchaValue) {
      //   setErrorMessege('Please verify the reCAPTCHA.');
      //   return;
      // } else {
      //   setErrorMessege(null);
  
      //   const secretKey = process.env.RECAPTCHA_SECRET_KEY; // Use a public environment variable
      //   const verificationUrl = `https://www.google.com/recaptcha/api/siteverify?secret=${secretKey}&response=${captchaValue}`;
  
      //   const response = await fetch(verificationUrl, {
      //     method: 'POST',
      //   });
  
      //   const data = await response.json();
  
      //   if (data.success) {
      //     // Proceed with the rest of your form submission logic
      //     console.log("reCAPTCHA verified successfully!");
      //   } else {
      //     setErrorMessege('Invalid reCAPTCHA.');
      //   }
      // }

      setIsLoading(true);
      const response = await fetch(process.env.FROM_SUBMIT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
          body: JSON.stringify(formData),
      });

      if (response.ok) {
        setIsLoading(false);
        setErrorMessege(null);
        setCaptchaValue(null);
        recaptchaRef.current.reset(); 
        setSuccessMesseage('Form submitted successfully');
        setFormData({
          title: '',
          firstName: '',
          lastName: '',
          phoneNumber: '',
          emailAddress: '',
          numberOfGuests: '',
          date: '',
          time: '',
          subject: '',
          message: '',
          consent: false,
          type: 'Private Party Inquiry',
        });
      } else {
        setIsLoading(false);
        setSuccessMesseage(null);
        setCaptchaValue(null);
        recaptchaRef.current.reset(); 
        setErrorMessege('Failed to submit form.');
      }
    } else {
      setErrors(formErrors);
      recaptchaRef.current.reset(); 
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      const page = await getPageData();
      if(page){
        if(page.pageData){
         // console.log(page);
          setPageData(page.pageData);
          if(page.pageData.pageBan){
            if(page.pageData.pageBan.bannerText){
              setPageBannerText(page.pageData.pageBan.bannerText);
            }
            if(page.pageData.pageBan.bannerSlider){
              setPageBannerSliders(page.pageData.pageBan.bannerSlider);
            }
          }

          if(page.pageData.privatePartyPage){
            if(page.pageData.privatePartyPage.overviewCreativeHeading){
              setOverviewCreativeHeading(page.pageData.privatePartyPage.overviewCreativeHeading);
            }
            if(page.pageData.privatePartyPage.overviewHeading){
              setOverviewHeading(page.pageData.privatePartyPage.overviewHeading);
            }
            if(page.pageData.privatePartyPage.overviewText){
              setOverviewText(page.pageData.privatePartyPage.overviewText);
            }
            if(page.pageData.privatePartyPage.formTitle){
              setFormHeading(page.pageData.privatePartyPage.formTitle);
            }
            if(page.pageData.privatePartyPage.exclusiveFloorTitle){
              setExclusiveFloorTitle(page.pageData.privatePartyPage.exclusiveFloorTitle);
            }
            if(page.pageData.privatePartyPage.exclusiveMenu){
              setExclusiveMenuList(page.pageData.privatePartyPage.exclusiveMenu);
            }
            if(page.pageData.privatePartyPage.floorPlans){
              setFloorMenuList(page.pageData.privatePartyPage.floorPlans);
            }
            if (page.pageData.privatePartyPage.enableExclusiveMenu) {
              setIsExclusiveMenu(page.pageData.privatePartyPage.enableExclusiveMenu);
            }
            if (page.pageData.privatePartyPage.enableFloorPlans) {
              setIsFloorPlans(page.pageData.privatePartyPage.enableFloorPlans);
            }
            
          }

        }
        if(page.qlparties){
          if(page.qlparties.nodes){
            setPartyList(page.qlparties.nodes);
          }
        }
        setPreLoaderEnable(false);
      }
    };

    fetchData();
    return () => {};
  }, []);


  useEffect( () => {
    (
      async () => {
          const LocomotiveScroll = (await import('locomotive-scroll')).default
          const locomotiveScroll = new LocomotiveScroll();
      }
    )()
  }, [])

  // if (pre_loader_enabled) {
  //   return <Loading />;
  // }

  return (
    <>
      {page_banner_sliders && page_banner_sliders.length !== 0 &&(
      <section className="inner-banner position-relative">
        <Carousel fade className='page-inner-carousel'>
        {page_banner_sliders.map((banner_img, index) => {

          let imgurl = '';

          if(banner_img.desktopImage){
            if(banner_img.desktopImage.node){
              if(banner_img.desktopImage.node.mediaItemUrl){
                imgurl = banner_img.desktopImage.node.mediaItemUrl;
              }
            }
          }

          return(
          <Carousel.Item key={index}>
            <Image
              className={styles.banner_section_main_img}
              src={imgurl}
              width={deviceType !== "mobile" ? 1920 : 400}
              height={deviceType !== "mobile" ? 1080 : 800}
              alt="Banner Image"
              priority
              quality={deviceType !== "mobile" ? 50 : 80}
            />
          </Carousel.Item>
          );}
          )}
        </Carousel>
        <div className='inner-banner-text'>
          <h2 className='all-caps section-heading-large section-heading--yellow'>{page_banner_text}</h2>
        </div>
      </section>
      )}
      {page_banner_sliders && page_banner_sliders.length === 0 &&(
      <section className="bg-dark-green green-mesh  inner-banner-text-wrap position-relative">
        <div className='inner-banner-text'>
          <h2 className='all-caps section-heading-large section-heading--yellow m-0'>{page_banner_text}</h2>
        </div>
      </section>
      )}


      {/* new design chamini */}

      <section className="section-padding-top section-padding-bottom bg-dark-green green-mesh ">
        <div className="middle-wrap z-top d-flex flex-wrap justify-content-between align-items-end">
          <div className={styles.firstPrivtePArty}>
              <h6 className="creativeheader creative-heading-small creative-heading--white text-center">
                {overview_creative_heading}
              </h6>
              <h1 className={`section-heading paragraph--whiteTxt tab-text-left all-caps text-center ${styles.headerTitleOv}`}>
                {overview_heading}
              </h1>
              <p className={`${styles.paraParty} paragraph paragraph--white text-center`}>
                {overview_text}
              </p>
          </div>
        </div>
      </section>

      <section className="section-padding-bottom bg-dark-green green-mesh partBoxSection">
        <div className="middle-wrap z-top">
          <div className={`${styles.party_box_wrap} party-box-wrap`}>
            {party_list.map((party_item, index) =>{


              let desc= "";
              let imgurl = "";
              let link = "";

              if(party_item.privateParty){
                if(party_item.privateParty.description){
                  desc = party_item.privateParty.description;
                }
                if(party_item.privateParty.reservenowlink){
                  link = party_item.privateParty.reservenowlink;
                }
                if(party_item.privateParty.featuredImage){
                  if(party_item.privateParty.featuredImage.node){
                    if(party_item.privateParty.featuredImage.node.mediaItemUrl){
                      imgurl = party_item.privateParty.featuredImage.node.mediaItemUrl;
                    }
                  }
                }
              }

              return(
            <div className={styles.party_box} key={index}>
              <div className={styles.party_box_inner}>
                <Image
                  src={imgurl}
                  width={deviceType !== "mobile" ? 500 : 360}
                  height={deviceType !== "mobile" ? 400 : 400}
                  alt="Banner Image"
                  quality={deviceType !== "mobile" ? 50 : 80}
                />
                <div className={styles.party_box_inner_title}>
                  <div>
                    <h6 className={`${styles.partyTitle} creative-heading--white all-caps text-left`}>{party_item.title}</h6>
                  </div>
                </div>
                <div className={styles.party_box_inner_content}>
                  <div className={styles.party_box_inner_content_inner}>
                    <h6 className={`${styles.partyTitle} creative-heading--white p-33 all-caps text-left`}>{party_item.title}</h6>
                    <p className={`${styles.descriptionParty} paragraph--white p-44`}>{desc}</p>
                    {link &&(
                    <a className="next-btn next-btn--black m-auto"
                      href={link}
                      >
                        <div className="reservation-btn">
                        <span className="next-btn--text">reserve now</span>
                        </div>
                        
                      </a>
                      )}
                  </div>
                </div>
              </div>
            </div>
            )})}
          </div>
        </div>
      </section>

      <section className={`${styles.PartyMenus} bg-dark-green green-mesh section-padding-bottom`}>
          <div className="lsmall-wrap">
            <h3 className={styles.exclusiveFloorTitle}>{exclusiveFloor_title}</h3>
          </div>          
          <div className="middle-wrap">
              <div className={styles.menuDown}>                  
                  <div className={`d-flex  ${styles.wrapDownMenuFloor}`}>
                    {is_exclusiveMenu &&(
                        <div className={styles.leftExMenu}>
                            <h3 className={styles.titlemenuex}>exclusive menus</h3>
                            <div className={styles.wrapExclusiveMenu}>
                                {ExclusiveMenuList.map((exmenuList, index) => {
                                  let listFileMenu= "";
                    
                                  listFileMenu = exmenuList?.exclusiveMenu?.exMenuFile?.node?.mediaItemUrl || '';             
                                  return(
                                    <div className={styles.party_box} key={index}>
                                      <div className={`d-flex ${styles.wrapMenuEx}`}>
                                          <div className={styles.menuType}>
                                              {exmenuList.exMenuType}
                                          </div>
                                          <div className={styles.downMenuType}>
                                          {exmenuList &&(
                                            <div className={`d-flex z-top button-menu justify-content-center ${styles.btn_inerOfferDown} `}>
                                              <a
                                                  target="_blank"
                                                  className={`${styles.download_menu} next-btn next-btn--yellow`}
                                                  href={listFileMenu}
                                                >
                                                  <span className={`all-caps ${styles.span_menuNameParty}`} >download menu</span>
                                                  <Image
                                                    src="/down-arr-w.png"
                                                    width={15}
                                                    height={10}
                                                    alt="Down arrow"
                                                  />
                                                </a>
                                            </div>
                                        )}
                                              
                                          </div>
                                      </div>
                                    </div>
                                  )}
                                )}
                            </div>
                        </div>
                    )}
                    {is_floorPlans &&(
                        <div className={styles.rightExMenu}>
                            <h3 className={styles.titlemenuex}>floor plans</h3>
                            <div className={styles.wrapExclusiveMenu}>
                                {FloorMenuList.map((exmenuList, index) => {
                                  let listFileMenu= "";
                    
                                  listFileMenu = exmenuList?.exclusiveMenu?.exMenuFile?.node?.mediaItemUrl || '';             
                                  return(
                                    <div className={styles.party_box} key={index}>
                                      <div className={`d-flex ${styles.wrapMenuEx}`}>
                                          <div className={styles.menuType}>
                                              {exmenuList.floorNumber}
                                          </div>
                                          <div className={styles.downMenuType}>
                                          {exmenuList &&(
                                            <div className={`d-flex z-top button-menu justify-content-center ${styles.btn_inerOfferDown} `}>
                                              <a
                                                  target="_blank"
                                                  className={`${styles.download_menu} next-btn next-btn--yellow`}
                                                  href={listFileMenu}
                                                >
                                                  <span className={`all-caps ${styles.span_menuNameParty}`} >download menu</span>
                                                  <Image
                                                    src="/down-arr-w.png"
                                                    width={15}
                                                    height={10}
                                                    alt="Down arrow"
                                                  />
                                                </a>
                                            </div>
                                        )}
                                              
                                          </div>
                                      </div>
                                    </div>
                                  )}
                                )}
                            </div>
                        </div>
                    )}
                  </div>
              </div>
          </div>
      </section>



      {/* end new design */}





      <section id="formparty" className="bg-dark-meroon green-mesh bg-cream section-padding-top section-padding-bottom">
        <div className="small-wrap z-top">
          <h2
          className="section-heading section-heading--white text-center p-94">
           {form_heading}
          </h2> 
        </div>
        <div className="lsmall-wrap z-top">
        <form className="form-wrap" onSubmit={handleSubmit}>
            <div className="form-row d-flex flex-wrap justify-content-between">
              <div className="form-col-half d-flex flex-wrap justify-content-between">
                <div className="dropdown-div">
                  <label>Title<span>*</span></label>
                  <select name="title" value={formData.title} onChange={handleChange}>
                    <option value="">Select</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Ms.">Ms.</option>
                  </select>
                  {errors.title && <span className="error-msg">{errors.title}</span>}
                </div>
                <div className="input-div">
                  <label>First Name<span>*</span></label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Enter your first name here"
                  />
                  {errors.firstName && <span className="error-msg">{errors.firstName}</span>}
                </div>
              </div>
              <div className="form-col-half">
                <label>Last Name<span>*</span></label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Enter your last name here"
                />
                {errors.lastName && <span className="error-msg">{errors.lastName}</span>}
              </div>
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between">
              <div className="form-col-half">
                <label>Phone Number<span>*</span></label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="Enter your phone number here"
                />
                {errors.phoneNumber && <span className="error-msg">{errors.phoneNumber}</span>}
              </div>
              <div className="form-col-half">
                <label>Email Address<span>*</span></label>
                <input
                  type="email"
                  name="emailAddress"
                  value={formData.emailAddress}
                  onChange={handleChange}
                  placeholder="Enter your email address here"
                />
                {errors.emailAddress && <span className="error-msg">{errors.emailAddress}</span>}
              </div>
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between">
              <div className="form-col-third">
                <label>Number of Guests<span>*</span></label>
                <input
                  type={inputTypes.numberOfGuests}
                  name="numberOfGuests"
                  value={formData.numberOfGuests}
                  onChange={handleChange}
                  placeholder="Enter number of guests"
                  onFocus={() => handleFocus('numberOfGuests', 'number')}
                />
                {errors.numberOfGuests && <span className="error-msg">{errors.numberOfGuests}</span>}
              </div>
              <div className="form-col-third position-relative row-icon">
                <label>Date<span>*</span></label>
                <DatePicker
                  selected={formData.date}
                  onChange={handleDateChange}
                  dateFormat="MMMM d, yyyy"
                  className="custom-date-picker"
                  placeholderText="Select date"
                  minDate={new Date()}
                />
                <img src="/cal.png" width={20} height={20} alt="Down arrow" />
                {errors.date && <span className="error-msg">{errors.date}</span>}
              </div>
              <div className="form-col-third position-relative row-icon">
                <label>Time<span>*</span></label>
                <TimePicker
                  onChange={handleTimeChange}
                  value={formData.time}
                  className="custom-time-picker"
                  disableClock={true}
                  format="HH:mm"
                  clearIcon={null}
                />
                {/* <input
                type={inputTypes.time}
                name="time"
                value={formData.time}
                onChange={handleChange}
                placeholder="Select time"
                onFocus={() => handleFocus('time', 'time')}
                /> */}
                <img src="/time.png" width={20} height={20} alt="Down arrow" />
                {errors.time && <span className="error-msg">{errors.time}</span>}
              </div>
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between">
              <div className="form-col-full">
                <label>Subject<span>*</span></label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Enter your subject here"
                />
                {errors.subject && <span className="error-msg">{errors.subject}</span>}
              </div>
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between">
              <div className="form-col-full heading-padding">
                <label>Message<span>*</span></label>
                <input
                  type="text"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter your message here"
                />
                {errors.message && <span className="error-msg">{errors.message}</span>}
              </div>
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between">
              <div className="form-col-full">
                <h6 className="paragraph-small paragraph--white para-bold ">GDPR Compliance</h6>
                <p className="paragraph-small paragraph--white">By giving your confirmation you explicitly give consent for us to store and use this information to service your requests. If you do not consent we will not store any personal information and will only send an email with the relevant details in order to service your requests.</p>
                <label className="d-flex checked-lable">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={formData.consent}
                    onChange={handleChange}
                  />
                  <p className="paragraph-small paragraph--white m-0">I confirm I have read and given consent for the above.</p>
                </label>
                {errors.consent && <span className="error-msg">{errors.consent}</span>}
                <p className="paragraph-xsmall paragraph--white form-para">This site is protected by reCAPTCHA and the Google <a href="https://www.anantara.com/en/privacy-policy" target="_blank">Privacy Policy</a> and <a href="https://sin.seenrooftopbangkok.emarketingeye.net/terms-conditions/" target="_blank">Terms of Service</a> apply.</p>
                <label className="ex-small"><span>*</span>required fields</label>
              </div>
            </div>
            <div className="recaptcha-wrap">
            <ReCAPTCHA
                ref={recaptchaRef} 
                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
              />
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between p-0">
              <div className="form-col-full d-flex aling-items-center">
                <button disabled={is_loading} type="submit" className="reserve-btn reserve-btn--yellow section-heading--white">Reserve Now</button>
                {is_loading &&(
                <Image
                  className="loader"
                  src="/loader.gif"
                  width={50}
                  height={50}
                  alt="corner border"
                />
                )}
              </div>
            </div>
            <div className="form-row d-flex flex-wrap justify-content-between p-0">
              <div className="form-col-full">
                {success_msg &&(
                  <div className="succes-msg-div">{success_msg}</div>
                )}
                {error_messege &&(
                  <div className="error-msg-div">{error_messege}</div>
                )}
              </div>
            </div>
          </form>
        </div>
      </section>
    </>
  )
}
